import Service from '@/helpers/service'

export default {

    index(params) {
        return Service().get('mobile-attendance-review/index', {params});
    },
    approve(id) {
        return Service().post('mobile-attendance-review/approve/'+id);
    },
    reject(id) {
        return Service().post('mobile-attendance-review/reject/'+id);
    },
    // The selfie is served behind JWT auth (per-employee privacy, same as
    // karyawan/photo) -- a plain <img src> can't carry that header, so this
    // goes through axios as a blob instead.
    selfie(id) {
        return Service().get('mobile/attendance/selfie/'+id, {responseType: 'blob'});
    },
}
